import { datadogRum } from '@datadog/browser-rum'
import { reactPlugin } from '@datadog/browser-rum-react'

import { DatadogRumInitConfig } from './types'

const UUID_PATTERN =
  /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi

let isDatadogRumInitialized = false
const viewStack: string[] = []

const getViewName = (pathname: string) => {
  return pathname
    .replace(UUID_PATTERN, ':uuid')
    .replace(/\/\d+(?=\/|$)/g, '/:id')
}

export const initDatadogRum = ({
  applicationId,
  clientToken,
  service,
  version,
  env,
  site = 'us5.datadoghq.com',
  sessionSampleRate = 100,
  sessionReplaySampleRate = 20
}: DatadogRumInitConfig) => {
  if (isDatadogRumInitialized) {
    return
  }

  if (window.location.pathname.startsWith('/pdf/')) {
    return
  }

  datadogRum.init({
    applicationId,
    clientToken,
    site,
    service,
    env,
    version,
    sessionSampleRate,
    sessionReplaySampleRate,
    trackResources: true,
    trackUserInteractions: true,
    trackLongTasks: true,
    trackViewsManually: true,
    trackingConsent: 'not-granted',
    defaultPrivacyLevel: 'mask-user-input',
    // React Router v5 is not supported by Datadog's router wrapper (v6+).
    plugins: [reactPlugin({ router: false })]
  })

  isDatadogRumInitialized = true
}

export const startDatadogView = (pathname: string) => {
  if (!isDatadogRumInitialized || !pathname) {
    return
  }

  viewStack.push(pathname)
  datadogRum.setTrackingConsent('granted')
  datadogRum.startView({
    name: getViewName(pathname)
  })
}

export const stopDatadogView = (pathname?: string) => {
  if (!isDatadogRumInitialized) {
    return
  }

  if (pathname) {
    const viewIndex = viewStack.lastIndexOf(pathname)

    if (viewIndex >= 0) {
      viewStack.splice(viewIndex, 1)
    }
  } else if (viewStack.length > 0) {
    viewStack.pop()
  }

  if (viewStack.length === 0) {
    datadogRum.setTrackingConsent('not-granted')

    return
  }

  const currentPathname = viewStack[viewStack.length - 1]
  datadogRum.startView({
    name: getViewName(currentPathname)
  })
}

export const setDatadogUser = (user: { id: string; email?: string }) => {
  if (!isDatadogRumInitialized) {
    return
  }

  datadogRum.setUser(user)
}

export const clearDatadogUser = () => {
  if (!isDatadogRumInitialized) {
    return
  }

  datadogRum.clearUser()
}
